const PersonFileds = {
  CPF: 1,
};

export default PersonFileds;
